<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row style="padding-top: 25px">
      <div class="topBorder">
        <van-row class="topDetail">
          <van-col span="18">
            <p class="earningTopic">{{ $t("bonus.totalEarnings") }}</p>
            <p class="earningAmount">${{ totalEarnings }}</p>
          </van-col>
          <van-col span="6" style="text-align: right">
            <img src="../images/bonus/user.png" class="imageright" />
          </van-col>
        </van-row>
      </div>
    </van-row>
    <!-- ------------------- bonus types ----------------- -->
    <van-row>
      <div
        v-for="(item, index) in userLevels"
        v-if="item.bonus_page_top == 1"
        :key="index"
      >
        <van-col span="12">
          <div class="outerContent">
            <div class="innerContent">
              <div class="bonusTypeBG">
                <img
                  src="../images/bonus/crown.png"
                  style="height: 40px; width: auto; margin-top: 8px"
                />
                <div style="padding: 5px">
                  <p class="bonusTypeTopic">{{ item[lang] }}</p>
                  <p class="bonusTypeDesc">
                    {{ item["content_" + lang] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </van-col>
      </div>
    </van-row>

    <!-- ------------------- divider --------------- -->
    <van-row style="margin: 20px 10px 0px; border: 1px solid #ffffff"></van-row>

    <!-- -------------------- detail bonus------------- -->

    <van-row
      style="padding-top: 10px"
      v-for="item in userLevels"
      :key="item.id"
      v-if="item.bonus_page_bottom == 1"
    >
      <div
        v-bind:class="[
          item.id == currentUserLevel ? 'outerContent' : 'outerContentTwo',
        ]"
        style="padding: 0px"
      >
        <van-row style="display: flex; align-items: center">
          <van-col span="14">
            <div class="typeBG">
              <div style="align-items: center; display: flex">
                <img
                  src="../images/bonus/crown.png"
                  style="height: 35px; width: auto"
                />
                <p class="bonusTopicItem">{{ item[lang] }}</p>
              </div>
            </div>
          </van-col>
          <van-col
            span="10"
            style="text-align: right"
            v-if="item.id == currentUserLevel"
          >
            <div class="SignIn" @click="dailyBonusCheckIn()">
              <p>{{ $t("bonus.signIn") }}</p>
            </div>
          </van-col>
        </van-row>
        <van-row style="padding: 15px 0px">
          <van-col span="8" style="text-align: center">
            <p class="value">
              {{ item.daily_reward
              }}<span class="timePeriod">/{{ $t("bonus.daily") }}</span>
            </p>
          </van-col>
          <van-col span="8" style="text-align: center">
            <p class="value">
              {{ item.weekly_reward
              }}<span class="timePeriod">/{{ $t("bonus.weekly") }}</span>
            </p>
          </van-col>
          <van-col span="8" style="text-align: center">
            <p class="value">
              {{ item.monthly_reward
              }}<span class="timePeriod">/{{ $t("bonus.once") }}</span>
            </p>
          </van-col>
        </van-row>
        <van-row style="padding: 0px 0px 15px">
          <van-col span="8" style="text-align: center">
            <div class="bonusType">
              <div
                class="bonusTypeItem"
                @click="
                  item.id <= currentUserLevel
                    ? showDailyBonusPopup()
                    : (levelErrorPopup = true)
                "
              >
                <img
                  src="../images/bonus/gift.png"
                  style="height: 35px; width: auto"
                />
                <p>{{ $t("bonus.dailyReward") }}</p>
              </div>
            </div>
          </van-col>
          <van-col span="8" style="text-align: center">
            <div class="bonusType">
              <div
                class="bonusTypeItem"
                @click="
                  item.id <= currentUserLevel
                    ? showWeeklyBonusPopup()
                    : (levelErrorPopup = true)
                "
              >
                <img
                  src="../images/bonus/gift.png"
                  style="height: 35px; width: auto"
                />
                <p>{{ $t("bonus.weeklyReward") }}</p>
              </div>
            </div>
          </van-col>
          <van-col span="8" style="text-align: center">
            <div class="bonusType">
              <div
                class="bonusTypeItem"
                @click="
                  item.id <= currentUserLevel
                    ? showOnceBonusPopup()
                    : (levelErrorPopup = true)
                "
              >
                <img
                  src="../images/bonus/gift.png"
                  style="height: 35px; width: auto"
                />
                <p>{{ $t("bonus.onceReward") }}</p>
              </div>
            </div>
          </van-col>
        </van-row>
      </div>
    </van-row>
    <!-- --------------------- bonus rules button ----------- -->
    <van-row style="padding: 25px 10px 0px">
      <van-col
        span="24"
        style="align-items: center; display: flex; flex-direction: column"
        ><router-link to="/bonusrules">
          <p class="bonusBtnText">{{ $t("bonus.bonusRules") }}</p>
        </router-link>
      </van-col>
    </van-row>
    <!-- ===================== Daily bonus sign up popup ================ -->
    <van-popup
      v-model="dailyBonusPopup"
      style="width: 90%; border-radius: 15px"
      @closed="onBonusPopupClose()"
    >
      <van-row class="signInPopBg" style="padding: 10px">
        <van-row>
          <van-row style="padding: 0px 5px">
            <!-- ---------close icon ------ -->
            <van-row>
              <van-col span="24" style="text-align: right">
                <img
                  src="../images/bonus/closeIcon.png"
                  style="height: 18px; width: auto"
                  @click="dailyBonusPopup = false"
                />
              </van-col>
            </van-row>
            <!-- ---------topic ------ -->
            <van-row>
              <van-col span="24">
                <p class="bonusPopTopic">{{ $t("bonus.signUpSuccess") }}</p>
              </van-col>
            </van-row>
            <!-- ---------records ------ -->
            <div class="recordList" ref="msgContainer">
              <!-- <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('bonus.loadFinish')"
                @load="onLoad"
                offset:4
                immediate-check:false
              > -->
              <van-row
                style="padding-top: 10px"
                v-for="item in bonusLog"
                :key="item.id"
              >
                <van-col span="12">
                  <p class="bonusDate">{{ getDate(item.time) }}</p>
                </van-col>
                <van-col span="12" style="text-align: right">
                  <p class="bonusBmount">{{ item.amount }} U</p>
                </van-col>
              </van-row>
              <!-- </van-list> -->

              <!-- ---- load more --- -->
              <van-row v-if="!finished">
                <van-col span="24" class="moreBtnBg" @click="onLoad()">
                  <p class="moreBtn">
                    {{ $t("bonus.more") }}
                    <img src="../images/bonus/more.png" class="moreIcon" />
                  </p>
                </van-col>
              </van-row>
            </div>
            <!-- -----------amount--------- -->
            <van-row class="inputBg" style="margin-top: 10px">
              <van-col span="12">
                <p class="amountText">{{ $t("bonus.amount") }} :</p></van-col
              >
              <van-col span="12" style="text-align: right"
                ><input
                  type="number"
                  class="amountValue"
                  disabled
                  v-model="totalEarnings"
              /></van-col>
            </van-row>
            <!-- ------------ sign up btn ----------- -->
            <van-row style="padding: 30px 0px 20px">
              <van-col span="24">
                <div class="signUpBtnBg">
                  <p class="signUpBtnText">{{ $t("bonus.signUpSuccess") }}</p>
                </div>
              </van-col>
            </van-row>
          </van-row>
        </van-row>
      </van-row>
    </van-popup>
    <!-- ===================== Weekly bonus sign up popup ================ -->
    <van-popup
      v-model="weeklyBonusPopup"
      style="width: 90%; border-radius: 15px"
      @closed="onBonusPopupClose()"
    >
      <van-row class="signInPopBg" style="padding: 10px">
        <van-row>
          <van-row style="padding: 0px 5px">
            <!-- ---------close icon ------ -->
            <van-row>
              <van-col span="24" style="text-align: right">
                <img
                  src="../images/bonus/closeIcon.png"
                  style="height: 18px; width: auto"
                  @click="weeklyBonusPopup = false"
                />
              </van-col>
            </van-row>
            <!-- ---------topic ------ -->
            <van-row>
              <van-col span="24">
                <p class="bonusPopTopic">{{ $t("bonus.signUpSuccess") }}</p>
              </van-col>
            </van-row>
            <!-- ---------records ------ -->
            <div class="recordList">
              <!-- <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('bonus.loadFinish')"
                @load="onLoad"
                offset:4
                immediate-check:false
              > -->
              <van-row
                style="padding-top: 10px"
                v-for="item in bonusLog"
                :key="item.id"
              >
                <van-col span="12">
                  <p class="bonusDate">{{ getDate(item.time) }}</p>
                </van-col>
                <van-col span="12" style="text-align: right">
                  <p class="bonusBmount">{{ item.amount }} U</p>
                </van-col>
              </van-row>
              <!-- </van-list> -->
              <!-- ---- load more --- -->
              <van-row v-if="!finished" @click="onLoad()">
                <van-col span="24" class="moreBtnBg">
                  <p class="moreBtn">
                    {{ $t("bonus.more") }}
                    <img src="../images/bonus/more.png" class="moreIcon" />
                  </p>
                </van-col>
              </van-row>
            </div>
            <!-- ------------amount ------------ -->
            <van-row class="inputBg" style="margin-top: 80px">
              <van-col span="12">
                <p class="amountText">{{ $t("bonus.amount") }} :</p></van-col
              >
              <van-col span="12" style="text-align: right"
                ><input
                  type="number"
                  class="amountValue"
                  disabled
                  v-model="totalEarnings"
              /></van-col>
            </van-row>
            <!-- ------------ sign up btn ----------- -->
            <van-row style="padding: 30px 0px 20px">
              <van-col span="24">
                <div class="signUpBtnBg">
                  <p class="signUpBtnText">{{ $t("bonus.signUpSuccess") }}</p>
                </div>
              </van-col>
            </van-row>
          </van-row>
        </van-row>
      </van-row>
    </van-popup>
    <!-- ===================== Once bonus sign up popup ================ -->
    <van-popup
      v-model="onceBonusPopup"
      style="width: 90%; border-radius: 15px"
      @closed="onBonusPopupClose()"
    >
      <van-row class="signInPopBg" style="padding: 10px">
        <van-row>
          <van-row style="padding: 0px 5px">
            <!-- ---------close icon ------ -->
            <van-row>
              <van-col span="24" style="text-align: right">
                <img
                  src="../images/bonus/closeIcon.png"
                  style="height: 18px; width: auto"
                  @click="onceBonusPopup = false"
                />
              </van-col>
            </van-row>
            <!-- ---------topic ------ -->
            <van-row>
              <van-col span="24">
                <p class="bonusPopTopic">{{ $t("bonus.onceBonus") }}</p>
              </van-col>
            </van-row>
            <!-- ---------upload video ------ -->
            <div class="uploadList">
              <van-row style="padding-top: 20px">
                <van-col span="24">
                  <p class="uploadText">{{ $t("bonus.uploadVideo") }}</p>
                </van-col>
              </van-row>

              <!-- ----------- video list --------- -->

              <van-row
                style="margin-top: 10px"
                v-for="item in bonusLog"
                :key="item.id"
              >
                <div
                  v-if="item.status !== 0"
                  style="padding-top: 20px"
                  @click="showVideoPreview(item.id, item.video_link)"
                >
                  <van-row>
                    <van-col span="24">
                      <img
                        v-if="selectedPreviewId != item.id"
                        :src="item.video_thumbnail"
                        style="height: 200px; width: 100%"
                      />
                      <video
                        v-if="selectedPreviewId === item.id"
                        :src="video_link"
                        height="180"
                        width="100%"
                        controls
                      ></video>
                      <img
                        v-if="selectedPreviewId != item.id"
                        src="../images/detail/play.png"
                        class="addVideoImg"
                      />
                    </van-col>
                  </van-row>
                </div>

                <van-col
                  v-if="item.status === 0"
                  span="24"
                  class="addMoreVideo"
                >
                  <van-uploader
                    :after-read="uploadOnceVideo"
                    :click-upload="(selectedItemId = item.id)"
                    :multiple="false"
                    accept="video/*"
                  >
                    <img
                      src="../images/bonus/uploadVideo.png"
                      style="height: auto; width: 30px"
                    />
                  </van-uploader>
                </van-col>
              </van-row>
            </div>
            <!-- --------------amount---------- -->
            <van-row class="inputBg" style="margin-top: 10px">
              <van-col span="12">
                <p class="amountText">
                  {{ $t("bonus.totalAmountObtained") }}:
                </p></van-col
              >
              <van-col span="12" style="text-align: right"
                ><input
                  type="number"
                  class="amountValue"
                  disabled
                  v-model="totalEarnings"
              /></van-col>
            </van-row>
            <!-- ------------ sign up btn ----------- -->
            <van-row style="padding: 30px 0px 20px">
              <van-col span="24">
                <div class="signUpBtnBg">
                  <p class="signUpBtnText">{{ $t("bonus.Confirm") }}</p>
                </div>
              </van-col>
            </van-row>
          </van-row>
        </van-row>
      </van-row>
    </van-popup>
    <!-- ===================== wrong level error popup ================ -->
    <van-popup
      v-model="levelErrorPopup"
      style="width: 90%; border-radius: 15px"
    >
      <van-row class="signInPopBg" style="padding: 10px">
        <van-row>
          <van-row style="padding: 0px 5px">
            <!-- ---------close icon ------ -->
            <van-row>
              <van-col span="24" style="text-align: right">
                <img
                  src="../images/bonus/closeIcon.png"
                  style="height: 18px; width: auto"
                  @click="levelErrorPopup = false"
                />
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24" style="text-align: center">
                <img
                  src="../images/bonus/tips.png"
                  style="height: 90px; width: auto"
                />
              </van-col>
            </van-row>
            <van-row>
              <van-col span="24" style="padding: 10px 0px 20px">
                <p class="errorMessage">
                  {{ $t("bonus.upgradeLevelHeading") }}
                </p>
                <p class="errorMessage">{{ $t("bonus.upgradeLevel") }}</p>
              </van-col>
            </van-row>
          </van-row>
        </van-row>
      </van-row>
    </van-popup>
    <van-dialog
      v-model:show="show"
      :title="$t('confirmDialog.uploading')"
      :showConfirmButton="false"
      :showCancelButton="false"
    >
      <van-progress
        v-if="progress != 100"
        style="margin: 10px 20px 20px 10px"
        :percentage="progress"
        stroke-width="8"
      />
      <van-loading
        size="24px"
        vertical
        v-if="progress == 100"
        style="margin: 10px 20px 20px 10px"
        >{{ $t("confirmDialog.wait") }}</van-loading
      >
    </van-dialog>

    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import Footer from "../../components/footer";
import {
  Icon,
  Col,
  Row,
  Popup,
  List,
  Loading,
  Uploader,
  Dialog,
  Progress,
} from "vant";
import Fetch from "../../utils/fetch";
import moment from "moment";
Vue.use(Icon)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(List)
  .use(Loading)
  .use(Uploader)
  .use(Dialog)
  .use(Progress);

export default {
  name: "bonus",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      userLevels: [],
      currentUserLevel: 0,
      totalEarnings: 0,
      dailyBonusPopup: false,
      weeklyBonusPopup: false,
      onceBonusPopup: false,
      levelErrorPopup: false,
      bonusLog: [],
      currentPage: 1,
      finished: false,
      type: 0,
      show: false,
      progress: 0,
      selectedItemId: 0,
      showPreview: false,
      selectedPreviewId: 0,
      video_link: "",
    };
  },
  mounted() {
    this.getTotalEarnings();
    this.getUserLevels();
  },
  methods: {
    getUserLevels() {
      Fetch("/user/user_level")
        .then((res) => {
          this.userLevels = res.data;
        })
        .catch(() => {});
    },
    dailyBonusCheckIn() {
      Fetch("/bonus/bonus_checkin")
        .then((res) => {
          if (res.code) {
            this.getTotalEarnings();
            this.$toast.success();
          }
        })
        .catch(() => {});
    },
    getTotalEarnings() {
      Fetch("/user/info")
        .then((res) => {
          this.totalEarnings = res.data.bonus;
          this.currentUserLevel = res.data.level;
        })
        .catch(() => {});
    },
    showDailyBonusPopup() {
      this.type = 1;
      this.getBonusLog().then(() => {
        this.dailyBonusPopup = true;
      });
    },
    showWeeklyBonusPopup() {
      this.type = 2;
      this.getBonusLog().then(() => {
        this.weeklyBonusPopup = true;
      });
    },
    showOnceBonusPopup() {
      this.type = 3;
      this.getBonusLog().then(() => {
        this.onceBonusPopup = true;
      });
    },
    getBonusLog() {
      return Fetch("/bonus/bonus_log", {
        num: 5,
        page: this.currentPage,
        reward_type: this.type,
      }).then((res) => {
        if (res.data.length == 0) this.finished = true;
        this.bonusLog = this.bonusLog.concat(res.data);

        window.scrollTo(
          0,
          document.body.scrollHeight || document.documentElement.scrollHeight
        );
        return true;
      });
    },
    uploadOnceVideo(selectedFile) {
      if (this.bonusLog.length > 0) {
        this.show = true;
        Fetch(
          "/uploads/video_upload_log",
          { file: selectedFile.file, id: this.selectedItemId },
          {},
          false,
          true,
          this.onProgressChange
        ).then((r) => {
          this.show = false;
          this.$toast.success();
          this.bonusLog = [];
          this.getBonusLog();
        });
      }
    },
    getDate(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    onLoad() {
      this.currentPage++;
      this.getBonusLog();
    },
    onBonusPopupClose() {
      this.currentPage = 1;
      this.bonusLog = [];
      this.finished = false;
      this.showPreview = false;
    },
    onProgressChange(progress) {
      this.progress = progress;
    },
    showVideoPreview(id, video_link) {
      this.showPreview = true;
      this.selectedPreviewId = id;
      this.video_link = video_link;
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
  padding-bottom: 80px;
}

.topBorder {
  padding: 10px 15px;
  border: 2px solid #ffffff;
  border-radius: 8px;
  margin: 0px 15px 15px;
}

.topDetail {
  align-items: center;
  display: flex;
  justify-content: center;
}

.earningTopic {
  color: #ffffff;
  font-size: 18px;
}

.earningAmount {
  font-size: 30px;
  padding-top: 10px;
  background: #ff9a00;
  background: linear-gradient(to top, #ff9a00 0%, #ffff00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}

.imageright {
  height: 40px;
  width: auto;
}

.outerContent {
  background-image: linear-gradient(#f2d627, #e29218);
  margin: 10px 10px 0px;
  border-radius: 10px;
  padding: 5px;
}

.innerContent {
  background: url("../images/bonus/bonusItem.png");
  background-size: 100% 100%;
}

.bonusTypeBG {
  display: flex;
  align-items: center;
  padding: 0px 10px 10px;
}
.bonusTypeTopic {
  color: #000000;
  font-size: 15px;
  font-weight: 700;
  padding: 5px 0px;
}
.bonusTypeDesc {
  color: #000000;
  font-size: 9px;
  margin-top: 4px;
  word-break: break-word;
}

.typeBG {
  color: #ffffff;
  font-size: 14px;
  background-image: linear-gradient(#f2d627, #e29218);
  padding: 4px 10px;
  border-radius: 10px 0px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
}

.bonusTopicItem {
  background: linear-gradient(to top, #ffb539 0%, #fefefe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 25px;
  font-weight: 800;
  filter: drop-shadow(1px 1px #00000099);
  padding-left: 8px;
  white-space: nowrap;
}

.SignIn {
  color: #ff8917;
  font-size: 15px;
  border: 1px solid #ffffff;
  padding: 4px;
  border-radius: 5px;
  width: fit-content;
  text-align: center;
  margin-right: 10px;
  float: right;
  background-image: linear-gradient(#fefdf4, #f9ef9f);
  font-weight: 700;
}

.value {
  font-size: 18px;
  color: #ffffff;
  font-weight: 700;
}

.timePeriod {
  font-size: 14px;
  font-weight: 100;
}

.bonusType {
  background: url("../images/bonus/bonusTypes.png");
  background-size: 100% 100%;
  margin: 0px 2px;
  padding: 10px;
}

.bonusTypeItem {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.bonusTypeItem p {
  color: #000000;
  font-size: 14px;
  padding-top: 6px;
}

.outerContentTwo {
  border: 1px solid #ffffff;
  margin: 10px 10px 0px;
  border-radius: 10px;
  padding: 5px;
  background: #ebebeb29;
}

.bonusBtnText {
  font-size: 24px;
  padding: 10px 20px;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 30px;
  width: fit-content;
  text-align: center;
  margin: 4px;
}

.signInPopBg {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.24);
  border-radius: 12px;
}

.bonusPopTopic {
  color: #000000;
  font-size: 18px;
  text-align: center;
  font-weight: 700;
  padding-top: 10px;
}

.bonusDate {
  color: #000000;
  font-size: 14px;
}

.bonusBmount {
  color: #ff0000;
  font-size: 14px;
  font-weight: 700;
}

.recordList {
  padding: 15px 0px 100px;
  height: 190px;
  // overflow-y: auto;
  margin-top: 15px;
  margin-bottom: 100px;
}

.recordList::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.recordList {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.moreIcon {
  height: 10px;
  width: auto;
  padding-left: 15px;
}

.moreBtnBg {
  border: 1px solid #d3d5d6;
  border-radius: 5px;
  padding: 5px 10px;
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.moreBtn {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #969799;
}

.inputBg {
  background: #f2f3f5;
  border-radius: 7px;
  padding: 10px 5px;
  align-items: center;
  display: flex;
}

.amountText {
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  word-break: break-word;
}

.amountValue {
  color: #ff0000;
  font-size: 18px;
  font-weight: 700;
  width: 100%;
  text-align: right;
}

.signUpBtnBg {
  background: url(../images/member/settingBg.png);
  background-size: 100% 100%;
}

.signUpBtnText {
  color: #000000;
  font-size: 20px;
  text-align: center;
  padding: 12px 0px;
}

.uploadText {
  color: #ff9100;
  font-weight: 700;
  font-size: 14px;
}

.addVideoImg {
  height: auto;
  width: 30px;
  position: absolute;
  left: 46%;
  top: 38%;
  right: 46%;
}

.addMoreVideo {
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(255, 215, 0, 0.13) 0%,
    rgba(255, 145, 0, 0.13) 100%
  );
  border: 1px solid #ff9920;
  border-radius: 6px;
  padding: 5px;
}

.errorMessage {
  color: #000000;
  font-size: 16px;
  text-align: center;
  padding-top: 10px;
}
</style>
<style lang="less">
.van-uploader,
.van-uploader__wrapper,
.van-uploader__input-wrapper,
.van-uploader__input {
  width: 100%;
}
</style>
